/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface RouteHistoryState {
  prevRoute?: string,
  currentRoute?: string,
}

export const initialState: RouteHistoryState = {
  prevRoute: undefined,
  currentRoute: undefined,
};

export const routeHistorySlice = createSlice({
  name: 'routeHistory',
  initialState,
  reducers: {
    pushRoute: (state: RouteHistoryState, action: PayloadAction<{ route: string }>) => {
      state.prevRoute = state.currentRoute;
      state.currentRoute = action.payload.route === '' ? '/' : action.payload.route;
    },
    setCurrentRoute: (state: RouteHistoryState, action: PayloadAction<{ route: string }>) => {
      state.currentRoute = action.payload.route === '' ? '/' : action.payload.route;
    },
  },
});

export const { pushRoute, setCurrentRoute } = routeHistorySlice.actions;

export default routeHistorySlice.reducer;
